import { API_MARKETING_PATH, getMarketingClient } from '../api';
import { TemplateDataPagination, AgentReviewsResponse } from '../dtos';

const REVIEWS_PAGE_SIZE = 10;

export interface GetReviewsByAgentEmailFilters {
  agentEmail: string,
  query?: string,
}

export async function getReviewsByAgentEmail(filters: GetReviewsByAgentEmailFilters, pagination?: TemplateDataPagination): Promise<AgentReviewsResponse> {
  const client = await getMarketingClient();

  const { agentEmail, query } = filters;

  const { data } = await client.get<AgentReviewsResponse>(`${API_MARKETING_PATH}/template-data/agent-reviews`, {
    params: {
      email: agentEmail,
      query,
      limit: pagination?.pageSize ?? REVIEWS_PAGE_SIZE,
      afterId: pagination?.afterId,
    },
  });

  return data;
}
